import { render, staticRenderFns } from "./SettingsEmailsDialog.vue?vue&type=template&id=60c85326&scoped=true"
import script from "./SettingsEmailsDialog.vue?vue&type=script&lang=js"
export * from "./SettingsEmailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c85326",
  null
  
)

export default component.exports